<div class="app-admin-wrap">
    <div>
        <app-header></app-header>
    </div>
    <div class="side-content-wrap">
        <app-sidebar></app-sidebar>
    </div>
    <div class="main-content-wrap d-flex flex-column" 
    [ngClass]="{'sidenav-close': !navService.sidebarState.sidenavOpen, 'main-content-no-padding': route.currentRoute.mainNoPadding}">
        <router-outlet></router-outlet>
        <div class="flex-grow-1"></div>
        <app-footer *ngIf="!route.currentRoute.hideFooter"></app-footer>
        <div class="module-loader" [hidden]="!layout.moduleLoading">
            <div class="spinner spinner-bubble spinner-bubble-primary mr-3"></div>
        </div>
    </div>
</div>
<app-search *ngIf="searchService.searchOpen"></app-search>